<po-modal #poModalListItens class="modal-itens" [p-hide-close]="true" [p-click-out]="true" p-title="Itens Contados">
    <div class="po-pl-2 po-pr-2">
        <div *ngIf="listAllItems.length > 0">
            <po-table [p-height]="300" [p-sort]="true" [p-items]="listAllItems" [p-striped]="true"> </po-table>
        </div>
        <div class="po-text-center" style="height:90px;" *ngIf="listAllItems.length == 0">
            <p>Nenhum item contado</p>
        </div>
    </div>
</po-modal>

<po-modal #poModalConfirmFinish [p-hide-close]="true" [p-primary-action]="primaryAction"
    [p-secondary-action]="secondaryAction" p-title="Finalizar Contagem">
    <div class="po-text-center po-font-text-large po-pt-2 po-pb-2">
        <p>Deseja finalizar a contagem?</p>
    </div>
</po-modal>

<po-modal #modalBarCodeReader [p-click-out]="false" [p-hide-close]="true"
    [p-primary-action]="secondaryActionBarCodeReader" p-title="Leitor Código de barras">
    <app-barcode-reader #barCodeReader (onRead)="onReadBarcodeReader($event)"
        (onTurnOff)="turnOffBarcodeReader()"></app-barcode-reader>
</po-modal>
<div class="po-row">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-9">
        <p class="po-font-title">Contagem</p>
    </div>
</div>
<div class="po-row po-mt-2 po-mb-5">
    <po-container class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
            <div class="po-xl-10 po-lg-10 po-md-10 po-sm-10">
                <span class="po-text-color-01 po-font-text-bold">Descrição</span>
            </div>
            <div class="po-xl-2 po-lg-2 po-md-2 po-sm-2 po-text-right">
                <span class="po-text-color-01 po-font-text-bold" style="cursor: pointer;" (click)="seeDescription()">
                    <i *ngIf="seeDescriptionItens" class="an-fill an-caret-circle-up" style="font-size: 20px;"></i>
                    <i *ngIf="!seeDescriptionItens" class="an-fill an-caret-circle-down" style="font-size: 20px;"></i>
                </span>
            </div>
        </div>
        <div class="po-row" *ngIf="seeDescriptionItens">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Balanço</span>
                <po-input name="input" [ngModel]="InventoryModel.inventoryCode" p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Contagem</span>
                <po-input name="input" [ngModel]="inventoryCountModel.inventoryCountCode" p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Descrição da Contagem</span>
                <po-input name="input" [ngModel]="inventoryCountModel.inventoryCountDescription"
                    p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Data do Balanço</span>
                <po-input name="input" [ngModel]="InventoryModel.inventoryDate | date:'dd/MM/yyyy'"
                    p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Situação do Balanço</span>
                <po-input name="input" [ngModel]="inventoryStatus" p-disabled="true"></po-input>
            </div>
        </div>
    </po-container>
    <div #countCard style="height: 1px;width:1px;"></div>
    <po-container class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2">
        <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-text-color-01 po-font-text-bold">Contagem</span>
            </div>
        </div>
        <div class="po-row">
            <div style="display: flex; justify-content: flex-end; width: 98%;">
                <span class="po-font-text-smaller">Itens Contados: {{countedItems}}</span>
            </div>
        </div>
        <div class="po-row">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Produto</span>
                <po-input #productInput [(ngModel)]="productCodeInput" (p-blur)="onCountProductCode()"
                    (keyup.enter)="onCountProductCode()" (p-enter)="disableKeyboard()"
                    (keyup.tab)="onCountProductCode()" p-icon="an an-barcode" name="inputBarcode"
                    [p-no-autocomplete]="true">
                </po-input>
            </div>
            <po-button p-kind="primary" (p-click)="startBarCodeReader()" p-icon="an an-camera" p-label="Ler Cód. Barras"
                class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"></po-button>
        </div>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2">
            <app-inventory-count-detail-last-counted-card [lastCountedList]="lastCountedList" />
        </div>
    </po-container>
    <div class="po-row po-mt-1 po-mb-5">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mb-5">
            <po-button p-kind="primary" p-label="Consultar Itens Contados"
                class="po-pl-0 po-pr-0 po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"
                (p-click)="openItemsModal()"></po-button>
        </div>
    </div>
    <div class="po-row" style="margin-bottom:200px;">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <po-button p-kind="primary" p-label="Finalizar"
                class="po-pr-0 po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"
                (p-click)="poModalConfirmFinish.open()"></po-button>
        </div>
    </div>
</div>